import { Button, Checkbox, DialogActions, DialogContent, DialogTitle, List, ListItemButton, Stack, Typography } from "@mui/material"
import LayersIcon from "components/icons/other/layers"
import { saveAs } from "file-saver"
import { observer } from "mobx-react-lite"
import { useState } from "react"
import { useMainStore } from "store"
import Project from "store/project"
import ExportProjectDialogStore from "./store"

type Props = {
  project: Project
}

const ExportProjectDialog = observer(({ project }: Props) => {

  const [ store ] = useState(() => new ExportProjectDialogStore(Array.from(project.contents.values()).map(content => content.id)))
  const mainStore = useMainStore()

  const applyExport = async () => {
    const projects = [ project.save(store.val) ]
    const schemeIds = new Set<string>()
    for (let project of projects) 
      for (let content of project.contents) 
        schemeIds.add(content.schemeId)

    const schemes = Object.fromEntries(
      Array.from(schemeIds)
        .filter(schemeId => mainStore.schemes.has(schemeId))
        .map(schemeId => [ schemeId, mainStore.schemes.get(schemeId)!.data ])
    )

    const file = new File([ JSON.stringify({ projects, schemes }) ], project.slug + ".json", { type: "application/json" })
    saveAs(file)
  }

  return (
    <>
      <DialogTitle sx={{ pb: 0.5 }}>Экспорт данных</DialogTitle>
      <Typography color="text.secondary" mx={3} fontSize={12} fontWeight={600}>
        { project.name }
      </Typography>
      <DialogContent>
        <List disablePadding sx={{ width: 370 }}>
        { Array.from(project.contents.values()).map(content => (
          <ListItemButton
            sx={{ px: 0, borderBottom: 1, borderColor: "divider", color: store.val.has(content.id)? "text.primary": "text.secondary" }}
            onClick={() => store.toggle(content.id)}
            key={content.id}
          >
            <LayersIcon sx={{ fontSize: 19 }}/>
            <Stack ml={1.5} flexGrow={1}>
              <Typography fontWeight={600} fontSize={12}>{ content.name }</Typography>
              <Typography fontSize={10}>{ mainStore.schemes.get(content.schemeId)?.data.name }</Typography>
            </Stack>
            <Checkbox 
              checked={store.val.has(content.id)} 
            />
          </ListItemButton>
        )) }
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={applyExport} disabled={store.val.size === 0} variant="contained" color="secondary">
          Экспорт в файл
        </Button>
      </DialogActions>
    </>
  )
})

export default ExportProjectDialog